import { icons } from "styles/icons";
import iconSizes from "./Icon.config";
import type { IconProps } from "./Icon.d";

const Icon = ({ name, color, size }: IconProps) => {
  const IconComponent = icons[name];
  return <IconComponent boxSize={iconSizes[size]} color={color} />;
};

export default Icon;
